import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  TariffZoneElectricity,
  TariffZoneGas,
  type EnergyTypeDropdownVM,
  type Offer,
} from '@innogy/become-a-customer/shared/interfaces';
import { EnergyType } from '@essent/new-customer';
import { getEnergyTypeDropdownVM } from '@innogy/become-a-customer/shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { CrntIcon } from '@essent/current-web-angular';
import { CommonModule } from '@angular/common';

import { CommodityOfferLabels } from '../../../commodity-offers.model';
import { CommodityVerticalOfferDropdownTableComponent } from '../commodity-vertical-offer-dropdown-table/commodity-vertical-offer-dropdown-table.component';

@Component({
  selector: 'ed-commodity-vertical-offer-dropdown',
  templateUrl: './commodity-vertical-offer-dropdown.component.html',
  styleUrls: [
    './commodity-vertical-offer-dropdown.component.ed.scss',
    './commodity-vertical-offer-dropdown.component.essent.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    CommodityVerticalOfferDropdownTableComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    TrackLinkDirective,
    CrntIcon,
  ],
})
export class CommodityVerticalOfferDropdownComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() set offer(value: Offer | undefined) {
    const electricityData = value?.offerOverviews.find(
      (overview) => overview.energyType === EnergyType.ELECTRICITY
    );
    const gasEnergyData = value?.offerOverviews.find(
      (overview) => overview.energyType === EnergyType.GAS
    );

    this.electricityDropdownVM = electricityData
      ? getEnergyTypeDropdownVM(
          electricityData,
          TariffZoneElectricity.Zone1,
          EnergyType.ELECTRICITY
        )
      : undefined;
    this.gasDropdownVM = gasEnergyData
      ? getEnergyTypeDropdownVM(
          gasEnergyData,
          TariffZoneGas.Zone1,
          EnergyType.GAS
        )
      : undefined;
    this.dynamicPricingExpectedDeliveryRateTitle = value?.isDynamicProduct
      ? this.content?.dropdownDynamicPricingExpectedDeliveryRateTitle
      : undefined;
  }
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() expanded = false;
  @Output() viewTariffs = new EventEmitter<void>();
  @Output() collapse = new EventEmitter<void>();
  @Output() expand = new EventEmitter<void>();

  electricityDropdownVM?: EnergyTypeDropdownVM;
  gasDropdownVM?: EnergyTypeDropdownVM;
  dynamicPricingExpectedDeliveryRateTitle?: string;

  toggle() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.expand.emit();
    } else {
      this.collapse.emit();
    }
  }
}
